export default function TermsModal({ onAccept, onCancel }) {
  return (
    <div className="allie-terms-overlay">
      <div className="allie-terms-card">
        <h2 className="allie-terms-title">Terms for using Allie</h2>
        <p className="allie-terms-body">
          These resources are not intended as medical advice or to replace
          recommendations from your health care professional. Please consult
          your healthcare team for medical advice.
        </p>
        <button type="button" className="allie-terms-cancel" onClick={onCancel}>
          Cancel
        </button>
        <button type="button" className="allie-terms-accept" onClick={onAccept}>
          Yes, I understand
        </button>
      </div>
    </div>
  )
}
